import * as React from 'react';
import { css } from 'emotion';

const CORNER_BORDER_RADIUS = 5;

const leftPaneRules = css({
  backgroundColor: '#F9ECE4',
  borderTopLeftRadius: CORNER_BORDER_RADIUS,
  borderTopRightRadius: CORNER_BORDER_RADIUS,
  color: 'rgba(0, 0, 0, 0.87)',
  display: 'flex',
  flexDirection: 'column',
  fontSize: 25,
  fontWeight: 500,
  letterSpacing: '.2px',
  lineHeight: '30px',
  margin: 0,
  padding: '20px 15px',
  ' br': {
    display: 'none'
  },
  '@media(min-width: 601px)': {
    borderTopRightRadius: 'initial',
    borderBottomLeftRadius: CORNER_BORDER_RADIUS,
    width: 150,
    ' br': { display: 'block' }
  }
});

const pickerOverrides = (type: string) => {
  if (type === 'time') {
    return css({
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      textAlign: 'center'
    });
  }
  return null;
};

export type PickerType = 'date' | 'time';

export interface Props {
  render: () => any;
  type: PickerType;
}

const LeftPane: React.SFC<Props> = ({ render, type }) => {
  return <div className={`${leftPaneRules} ${pickerOverrides(type)}`}>{render()}</div>;
};

export { LeftPane };
